/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const profile_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.203 5.23c3.217 3.03 7.577 4.74 12.13 4.76 2.312-.001 4.6-.447 6.723-1.31m-6.928 7.858c-1.866 1.755-4.89 1.755-6.756 0m10.98-12.39c4.197 4.199 4.197 11.005 0 15.203-4.199 4.198-11.005 4.198-15.203 0C-.05 15.153-.05 8.347 4.149 4.15c4.198-4.2 11.004-4.2 15.201-.001Z"
    />
  </svg>
)
export default profile_medium
